var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "postit-board-container" }, [
    _c("div", { staticClass: "board-header" }, [
      _c(
        "h2",
        { staticClass: "board-title" },
        [
          _c("a-icon", { attrs: { type: "pushpin" } }),
          _vm._v(
            "\n      " + _vm._s(_vm.$t("message.postitBoardTitle")) + "\n    "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "a-button",
            {
              staticClass: "add-note-btn",
              attrs: { type: "primary" },
              on: { click: _vm.addNewNote },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.postitNewNoteButton")) +
                  "\n      "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "close-btn",
              attrs: { type: "default" },
              on: { click: _vm.closeBoardOverlay },
            },
            [_c("a-icon", { attrs: { type: "close" } })],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cork-board",
        on: {
          drop: _vm.handleDrop,
          dragover: _vm.handleDragOver,
          dblclick: _vm.addNoteAtPosition,
        },
      },
      [
        _c("div", { staticClass: "cork-pattern" }),
        _vm._v(" "),
        _vm._l(_vm.notes, function (note) {
          return _c("postit-note", {
            key: note.id,
            style: {
              left: note.x + "px",
              top: note.y + "px",
              transform: "rotate(" + note.rotation + "deg)",
            },
            attrs: { note: note },
            on: {
              edit: _vm.editNote,
              delete: _vm.deleteNote,
              "drag-start": _vm.handleNoteDragStart,
              "drag-end": _vm.handleNoteDragEnd,
            },
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.pins, function (pin) {
          return _c("div", {
            key: pin.id,
            staticClass: "pin",
            style: { left: pin.x + "px", top: pin.y + "px" },
          })
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.editorVisible
      ? _c(
          "div",
          {
            staticClass: "postit-editor-sidebar",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "editor-header" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.editorSidebarTitle))]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "close-editor-btn",
                    attrs: { type: "text" },
                    on: { click: _vm.closeEditor },
                  },
                  [_c("a-icon", { attrs: { type: "close" } })],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "editor-content" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.postitTitleLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "editor-input",
                    attrs: {
                      placeholder: _vm.$t("message.postitTitlePlaceholder"),
                    },
                    model: {
                      value: _vm.editorData.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.editorData, "title", $$v)
                      },
                      expression: "editorData.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.postitContentLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("a-textarea", {
                    staticClass: "editor-textarea",
                    attrs: {
                      placeholder: _vm.$t("message.postitContentPlaceholder"),
                      rows: 8,
                    },
                    model: {
                      value: _vm.editorData.text,
                      callback: function ($$v) {
                        _vm.$set(_vm.editorData, "text", $$v)
                      },
                      expression: "editorData.text",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.postitColorLabel"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "color-picker" },
                  _vm._l(_vm.postitColors, function (color) {
                    return _c(
                      "div",
                      {
                        key: color.name,
                        staticClass: "color-option",
                        class: { active: _vm.editorData.color === color.name },
                        style: { background: color.preview },
                        attrs: { title: color.label },
                        on: {
                          click: function ($event) {
                            _vm.editorData.color = color.name
                          },
                        },
                      },
                      [
                        _vm.editorData.color === color.name
                          ? _c("a-icon", {
                              staticClass: "check-icon",
                              attrs: { type: "check" },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.postitSizeLabel"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "size-controls" }, [
                  _c(
                    "div",
                    { staticClass: "size-row" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.postitWidthPx", {
                              w: _vm.editorData.width,
                            })
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-slider", {
                        attrs: { min: 150, max: 300 },
                        model: {
                          value: _vm.editorData.width,
                          callback: function ($$v) {
                            _vm.$set(_vm.editorData, "width", $$v)
                          },
                          expression: "editorData.width",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "size-row" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.postitHeightPx", {
                              h: _vm.editorData.height,
                            })
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-slider", {
                        attrs: { min: 150, max: 300 },
                        model: {
                          value: _vm.editorData.height,
                          callback: function ($$v) {
                            _vm.$set(_vm.editorData, "height", $$v)
                          },
                          expression: "editorData.height",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.postitAngleWithDeg", {
                          deg: _vm.editorData.rotation,
                        })
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-slider", {
                    attrs: { min: -15, max: 15, marks: _vm.angleSliderMarks },
                    model: {
                      value: _vm.editorData.rotation,
                      callback: function ($$v) {
                        _vm.$set(_vm.editorData, "rotation", $$v)
                      },
                      expression: "editorData.rotation",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-footer" },
              [
                _c("a-button", { on: { click: _vm.closeEditor } }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.cancel")) + "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: !_vm.editorData.title.trim(),
                    },
                    on: { click: _vm.saveNote },
                  },
                  [
                    _c("a-icon", { attrs: { type: "save" } }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.editorSaveButtonLabel) +
                        "\n      "
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }